export default __webpack_public_path__ + "static/media/unknown.a1b2e371.svg";